import { type FC } from 'react';
import { Controller } from 'react-hook-form';
import { RadioGroup } from '../../../../components/RadioGroup';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import { getFlagFromStatus, getStatusByFlag } from '../../../../types/boolean-flag';
import type {
  HubSpotConfigurationControl,
  HubSpotConfigurationFormValues,
} from '../../HubSpotConfigurationFormSchema';
import { AUTOMATICALLY_IMPORT_CUSTOMERS_OPTIONS } from './constants';

type CustomersConfigurationSectionProps = {
  control: HubSpotConfigurationControl;
  defaultValues: HubSpotConfigurationFormValues;
};

export const CustomersConfigurationSection: FC<CustomersConfigurationSectionProps> = ({
  control,
  defaultValues,
}) => (
  <ConfigurationSection title="Customers" iconName="Customers">
    <Controller
      name="autoImportCustomers"
      control={control}
      defaultValue={defaultValues.autoImportCustomers}
      render={({ field: { value, onChange } }) => (
        <RadioGroup
          title="Choose how to import customers from HubSpot"
          value={getFlagFromStatus(value)}
          onChange={(selected) => onChange(getStatusByFlag(selected))}
          keyExtractor={(option) => option.value}
          options={AUTOMATICALLY_IMPORT_CUSTOMERS_OPTIONS}
        />
      )}
    />
  </ConfigurationSection>
);
